
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { useState } from "react";
import { getBookingStatistic } from 'apis/booking';
import styles from './booking-statistic.module.scss';

import moment from 'moment';
import {
  DatePicker,
  Button
} from 'antd'
Chart.register(CategoryScale);

export default function BookingStatistic() {
  
  const [from, setFrom] = useState(moment());
  const [to, setTo] = useState(moment());
  
  const [chartData, setChartData] = useState(null
  );
  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: 'Dataset 1',
  //       data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
  //       backgroundColor: 'rgba(255, 99, 132, 0.5)',
  //     },
  //     {
  //       label: 'Dataset 2',
  //       data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
  //       backgroundColor: 'rgba(53, 162, 235, 0.5)',
  //     },
  //   ],
  // };

  const getData = async () => {
    const res = await getBookingStatistic({from_date: from.format('YYYY-MM-DD'), to_date: to.format('YYYY-MM-DD')})
    if (res.status === 200) {
        setChartData({
          'labels': ["All"],
          'datasets': res.data.data.datasets
        })
      
    }
    // setChartData({
    //   'labels': data.link,
    //   'datasets': data.datasets
    // })
  }




  return  (<div className={`${styles['pt-8']} container`} >
    <div className={`${styles['align-items-center']}  ant-row`}>
      <div className={`${styles['px-8']} ant-col ant-space-horizontal ant-space-align-center`} >
      <span> Lọc theo thời gian: </span>
      </div>
      <div className={`${styles['px-8']} ant-col ant-space-horizontal ant-space-align-center`}>
        <DatePicker defaultValue={from} 
        placeholder="Chọn ngày bắt đầu" style={{ width: '100%' }} onChange={setFrom}/>
      </div>
      <div  className={`${styles['px-8']} ant-col ant-space-horizontal ant-space-align-center`}> 
      <span> ~</span>
      </div>
      <div className={`${styles['px-8']} ant-col ant-space-horizontal ant-space-align-center`}>
        <DatePicker  defaultValue={to}  placeholder="Chọn ngày kết thúc" style={{ width: '100%' }} onChange={setTo}/>
      </div>
      <div cclassName={`${styles['px-8']} ant-col ant-space-horizontal ant-space-align-center`}>
      <Button onClick={getData} size="large" type="primary">
          Xuất dữ liệu
        </Button>
      </div>
    </div>
    <div class="row">
      
      <BarChart chartData={chartData}></BarChart>
    </div>
  </div>);
  
  
}

const BarChart = ({ chartData }) => {
  if(chartData != null) {
    return (
      <div className="chart-container">
        {/* <h2 style={{ textAlign: "center" }}>Bar Chart</h2> */}
        <Bar
          data={chartData}
          options={{
            plugins: {
              title: {
                display: true,
                text: 'Bar Chart'
              },
              legend: {
                display: true,
                position: 'top'
              }
            }
          }}
        />
      </div>
    );
  } else {
    return <div className="chart-container">
      <h2 style={{ textAlign: "center" }}>Bar Chart</h2>
    </div>
  }
};
